import { Component, Input } from '@angular/core';
import { IProductTypeLite } from 'lib-core-shared';

@Component({
  selector: 'lib-product-type-indicator',
  templateUrl: './product-type-indicator.component.html',
  styleUrls: ['./product-type-indicator.component.scss'],
})
export class ProductTypeIndicatorComponent {
  @Input() public productType!: IProductTypeLite;
  @Input() public size!: string;
}
